/* global axios */
import ApiClient from '../ApiClient';

class PolarisDocument extends ApiClient {
  constructor() {
    super('captain/documents', { accountScoped: true });
  }

  get({ page = 1, searchKey, assistantId, filter, source, sort } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        search_key: searchKey,
        assistant_id: assistantId,
        filter,
        source,
        sort,
      },
    });
  }

  sync(id) {
    return axios.post(`${this.url}/${id}/sync`);
  }

  // Conhecimento por conta (Fase 6): liga/desliga um assistente na fonte (a junção).
  attachAssistant(id, assistantId) {
    return axios.post(`${this.url}/${id}/assistants/${assistantId}`);
  }

  detachAssistant(id, assistantId) {
    return axios.delete(`${this.url}/${id}/assistants/${assistantId}`);
  }
}

export default new PolarisDocument();
